import React from "react";
import { useQuery } from "@tanstack/react-query";
import { GitBranch } from "lucide-react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUS = { borrador: "Borrador", compartido: "Compartida", vendido: "Vendida", no_vendido: "No vendida", perdido: "Perdida" };

export function CotVersionSwitcher({ cotId, onOpen }) {
  const q = useQuery({ queryKey: ["cot-versions", cotId], queryFn: async () => (await api.get(`/cotizaciones/${cotId}/versions`)).data });
  const versions = q.data?.versions || [];
  if (versions.length < 2) return null;
  return (
    <Select value={cotId} onValueChange={(id) => id !== cotId && onOpen?.(id)}>
      <SelectTrigger className="h-8 w-auto gap-1.5 text-xs" data-testid="cot-version-switcher">
        <GitBranch className="h-3.5 w-3.5 text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {versions.map((v) => (
          <SelectItem key={v.id} value={v.id} data-testid={`cot-version-${v.version || 1}`}>
            v{v.version || 1} · {STATUS[v.status] || v.status || "Borrador"}{v.trip_id ? " · Trip" : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
